export const getEmployerApplicationsRoute = '/employer/applications/filter';
export const getEnterpriseApplicationsRoute =
  '/enterprise/enterprises-application/filter/';
export const getApplicationsCountsRoute = '/employer/applications/counts/get';
export const getEnterpriseApplicationsCountsRoute =
  '/enterprise/enterprises-application/count/';
export const getEnterpriseCodes = '/enterprise/invites/get/?bulk=1';
export const getLogout = '/logout/';
export const searchApplicationsRoute = '/employer/applications/search/';
export const searchEnterpriseApplicationsRoute =
  '/enterprise/enterprises-application/search/';
export const applicantEnterpriseApplicationsRoute =
  '/enterprise/enterprises-application/applicant-applications/';
export const enterpriseBulkActionRoute =
  '/enterprise/enterprises-application/mass/';
export const bulkActionRoute = '/employer/applications/mass/';
export const enterpriseList = '/enterprise/locations/get/admin/';
export const updateApplicationNotesRoute = '/employer/applicants/notes/';
export const applicantApplicationsRoute = '/employer/applicants/applications/';
export const createApplicationManuallyRoute = '/employer/applicants/manual/';
export const createEnterpriseApplicationManuallyRoute =
  '/enterprise/applicants/manual/';
export const checkAvailableCalendarSlotsRoute =
  '/employer/calendar/blocks/verify/';
export const checkEnterpriseAvailableCalendarSlotsRoute =
  '/enterprise/calendar/blocks/verify/';
export const saveApplicantRoute = '/employer/applicants/save/';
export const hireApplicantRoute = '/employer/applicants/hire/';
export const declineApplicantRoute = '/employer/applicants/decline/';
export const archiveApplicantRoute = '/employer/applicants/archive/';
export const inviteToInterviewBlocksRoute = '/employer/calendar/blocks/invite/';
export const inviteToInterviewRoute = '/employer/calendar/invite/';
export const hireflixInviteToInterviewRoute =
  '/employer/hireflix/interview/invite/';
export const hireflixPurchasePlanRoute = '/employer/hireflix/purchase/credit/';
export const hireflixAutoRefillRoute = '/employer/hireflix/auto-refill/update/';
export const deleteHireflixRoute = '/employer/hireflix/interview/delete/';
export const getApplicantApplicationsRoute = '/applicants/applications/get/';
export const enterpriseLoginRoute = '/enterprise/locations/login/';
export const enterpriseTagsList = '/enterprise/tags/get/';
export const employerTagsList = '/employer/tags/get/';
export const createEnterpriseTagsRoute = '/enterprise/tags/create/';
export const createEmployerTagsRoute = '/employer/tags/create/';
export const updateEnterpriseTagsRoute = '/enterprise/tags/edit/';
export const updateEmployerTagsRoute = '/employer/tags/edit/';
export const deleteEnterpriseTagsRoute = '/enterprise/tags/delete/';
export const deleteEmployerTagsRoute = '/employer/tags/delete/';
export const assignTagsRoute = '/enterprise/tags/applicant/assign';
export const assignEmployerTagsRoute = '/employer/tags/applicant/assign';
export const assignApplicatintsCount = '/enterprise/tags/applicant/count';
export const assignEmployerApplicatintsCount = '/employer/tags/applicant/count';
export const deleteApplicantInterview = '/employer/calendar/invite/delete/';
export const interviewCountsRoute = '/employer/confirmed_interviews/count/';
export const interviewActionRoute = '/employer/interview_action/';
export const applicationHistoryRoute = '/employer/application/history/get/';
export const resendInterviewBlockRoute = '/applicants/request/calendar/block/';
